import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePostApiUserPersonalInformation } from '../../api/interconectar-api';
import { PersonalInformationCommand, PersonalInformationResponseViewModel } from '../../api';

export function useProfileAccountActions(): {
	personalInformationPost: (personalInformation: PersonalInformationCommand) => void;
	isLoading: boolean;
} {
	const { mutate: postUserPersonalInformation, isLoading } = usePostApiUserPersonalInformation();
	const navigate = useNavigate();
	const personalInformationPost = useCallback(
		(personalInformation: PersonalInformationCommand): void => {
			postUserPersonalInformation(
				{
					data: personalInformation,
				},
				{
					onSuccess(data, variables, context) {
						localStorage.setItem('fullName', `${personalInformation.name} ${personalInformation.surname}`);

						// Save personal information to localStorage
						const personalInfoToSave: PersonalInformationResponseViewModel = {
							name: personalInformation.name,
							surname: personalInformation.surname,
							countryCode: personalInformation.countryCode,
							mobileNumber: personalInformation.mobileNumber,
							country: personalInformation.country,
							companyName: personalInformation.companyName,
							companyPosition: personalInformation.companyPosition,
							avatar: personalInformation.avatar,
							notifications: personalInformation.notifications,
							notificationsEnabled: personalInformation.notificationEnabled,
						};
						localStorage.setItem('personalInformation', JSON.stringify(personalInfoToSave));

						navigate('/information', { state: { variation: 'register_ok' } });
					},
					onError(error, variables, context) {
						navigate('/information', { state: { variation: 'error' } });
					},
				},
			);
		},
		[postUserPersonalInformation, navigate],
	);

	return {
		personalInformationPost,
		isLoading,
	};
}
